import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Sparkles } from 'lucide-react';

/**
 * Affiche le dialogue « bonne nouvelle » lorsque l’analyse indique une économie possible,
 * sans exposer de libellés techniques côté contrat.
 */
export function economyCongratsEligible(result) {
  if (!result || typeof result !== 'object' || result.error) return false;
  if (result.has_savings === true) return true;
  if (result.economy_possible === true) return true;
  const ts = Number(result.savings_analysis?.total_savings ?? 0);
  if (!Number.isNaN(ts) && ts > 0) return true;
  const fl = result.financial_loss_contract_included;
  return (
    fl === true ||
    (typeof fl === 'string' && ['true', 'oui', 'yes', '1'].includes(fl.trim().toLowerCase()))
  );
}

export default function EconomyPossibleDialog({ open, onOpenChange, result, formatCurrency: _formatCurrency }) {
  if (!result) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-md border-green-200 bg-gradient-to-b from-green-50/95 to-white rounded-none"
        data-testid="economy-congrats-dialog"
      >
        <DialogHeader className="space-y-3">
          <div className="mx-auto flex h-14 w-14 items-center justify-center bg-green-600 text-white">
            <Sparkles className="h-7 w-7" aria-hidden />
          </div>
          <DialogTitle
            className="text-center text-xl font-bold text-green-900 font-heading"
          >
            Bonne nouvelle
          </DialogTitle>
          <DialogDescription asChild>
            <div className="space-y-3 text-center text-base text-neutral-700">
              <p>
                D&apos;après l&apos;analyse de votre document, une{' '}
                <strong>économie peut être envisagée</strong> sur votre contrat.
              </p>
              <p className="text-sm text-neutral-600">
                Nous n’affichons pas de montants ici : la synthèse du contrat figure ci-dessous ; le détail chiffré
                vous sera communiqué après inscription et validation de votre demande.
              </p>
            </div>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:justify-center">
          <button
            type="button"
            onClick={() => onOpenChange(false)}
            className="w-full sm:w-auto btn-green px-8 py-3 text-sm font-semibold"
          >
            Continuer
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
